<template>
  <v-expansion-panel >
     <!-- :eager="true" -->
    <v-expansion-panel-header id="expansion-cat" >
      <div class="d-flex smart-item">
        <v-layout text-right wrap>
          <v-flex pa-2 class>
            <v-layout wrap>
              <v-flex xl3 lg3 md3 xs12 class="smart-item-title">
                <span class="display-24">{{ text }}</span>
                <!-- <span
                  class="red--text display-14 d-block mt-1"
                  v-if="!selectedCategoryDetails"
                >
                  * {{ t(`titles.requiredField`) }}
                </span> -->
              </v-flex>
              <v-divider
                vertical
                class="ml-1"
                v-show="$vuetify.breakpoint.smAndUp"
              />
              <v-flex
                class="display-18 smart-item-fields py-2"
                align-self-center
              >
                {{ selectedCategoryDetails }}
                <span v-if="selectedSecondCat">
                  ,{{ selectedSecondCategoryDetails }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pa-0 mt-1">
      <v-layout wrap justify-space-between py-2>
        <v-flex md6 xs12  >
          <CategorySelect
            :selected="mainSelectedCategory"
            :items="items"
            class="firstCat pl-md-2 px-0"
            :category-num="1"
            :text="mainCategoryText"
            @displaySelectedCategory="handleSelectedCatDisplay"
            @selectSubCategories="handleSelectedSubCats"
          />
        </v-flex>

        <v-flex md6 xs12>
          <CategorySelect
            :selected="secondarySelectedCategory"
            :items="itemsWithoutSelected"
            :disabled="!selectedFirstCat"
            :category-num="2"
            class="pr-md-2 px-0"
            :text="secondaryCategoryText"
            @displaySelectedCategory="handleSecondSelectedCatDisplay"
            @selectSubCategories="handleSelectedSecondarySubCats"
            @unselectCat="unselectCategory"
          />
        </v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { without } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import CategorySelect from '@/components/Forms/Form_Fields/CategorySelect';
import { find, isEmpty } from 'lodash';

export default {
  components: {
    CategorySelect
  },

  props: {
    items: {
      type: Array
    },

    text: {
      type: String,
      default: ''
    },
    agentCode: {
      type: String,
      default: null,
      required: true
    }
  },

  data() {
    return {
      selectedFirstCat: undefined,
      selectedFirstSubCats: null,
      selectedSecondCat: undefined,
      selectedSecondSubCats: null
    };
  },

  mounted() {
  },

  computed: {
    ...mapGetters({
      getLocal: 'getLocal',
      CurrentUser: 'CurrentUser'
    }),

    ...mapState({
      mainCategoryText: state =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[2]
          .KeyValue.Value,
      secondaryCategoryText: state =>
        state.smartAlertsSettings.allSettingsData.KeysDictionary.Keys[4]
          .KeyValue.Value,
      allSettingsData: state => state.smartAlertsSettings.allSettingsData
    }),

    userSettings() {
      return this.CurrentUser
        ? find(this.CurrentUser.SmartAgents, {
            AgentCode: parseInt(this.agentCode)
          })
        : undefined;
    },

    mainSelectedCategory() {
      const { Categories } = this.userSettings;
      let mainCategory;

      if (isEmpty(Categories)) {
        return null;
      } else {
        mainCategory = Categories[0].Code;
        return mainCategory;
      }
    },

    secondarySelectedCategory() {
      const { Categories } = this.userSettings;
      let secondaryCategory;
      if (Categories.length > 1) {
        secondaryCategory = Categories[1];
        return secondaryCategory.Code;
      } else {
        return -1;
      }
    },

    selectedCategoryDetails() {
      return this.selectedFirstCat ? this.selectedFirstCat.NameInHebrew : '';
    },

    selectedSecondCategoryDetails() {
      return this.selectedSecondCat ? this.selectedSecondCat.NameInHebrew : '';
    },

    itemsWithoutSelected() {
      return without(this.items, this.selectedFirstCat);
    }
  },

  methods: {
    ...mapActions([
      'setMainCategory',
      'setMainSubCategories',
      'setSecondaryCategory',
      'setSecondarySubCategories'
    ]),

    handleSelectedCatDisplay(selectedCategory) {
      this.setMainCategory(selectedCategory);
      this.selectedFirstCat = selectedCategory;
    },

    handleSecondSelectedCatDisplay(selectedCategory) {
      this.setSecondaryCategory(selectedCategory);
      this.selectedSecondCat = selectedCategory;
    },

    handleSelectedSubCats(subCategoriesArr) {
      this.setMainSubCategories(subCategoriesArr);
    },

    handleSelectedSecondarySubCats(subCategoriesArr) {
      this.setSecondarySubCategories(subCategoriesArr);
    },

    unselectCategory(categoryNum) {
      if (categoryNum === 1) {
        this.setMainCategory(undefined);
      } else {
        this.selectedSecondCat = undefined;
        this.setSecondaryCategory(undefined);
      }
    }
  }
};
</script>

<style lang="scss" >

#smart-manager.v-expansion-panel-content__wrap {
  padding: 0;
}

#expansion-cat .v-expansion-panel--active > .v-expansion-panel-header {
  background: red;
}
@media only screen and (min-width: 920px) {
  .firstCat {
    border-left: 1px solid #eee;
  }
}
</style>
